import { __assign } from "tslib";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { TextCell } from "@pangeacyber/react-mui-shared";
import StoreObjectIcon from "../StoreObjectIcon";
import { Stack } from "@mui/material";
import { formatBytes } from "../../utils";
export var StoreViewerFields = {
    name: {
        label: "Name",
        cellClassName: "columnPrimary",
        width: 250,
        flex: 10,
        renderCell: function (params) {
            var _a, _b, _c;
            var value = params.value;
            var obj = params === null || params === void 0 ? void 0 : params.row;
            var mimeType = (_b = ((_a = obj.name) !== null && _a !== void 0 ? _a : "").split(".").at(-1)) !== null && _b !== void 0 ? _b : "";
            return (_jsxs(Stack, { direction: "row", alignItems: "center", spacing: 1, children: [_jsx(StoreObjectIcon, { type: obj.type, mimeType: mimeType, password: !!(obj === null || obj === void 0 ? void 0 : obj["vault-password-algorithm"]) ||
                            !!((_c = obj.metadata_protected) === null || _c === void 0 ? void 0 : _c["vault-password-algorithm"]) }), _jsx(TextCell, { params: params })] }));
        },
    },
    updated_at: {
        label: "Modified At",
        type: "stringDateTime",
        minWidth: 190,
    },
    size: {
        label: "Size",
        renderCell: function (params) {
            var value = params.value;
            try {
                if (!isNaN(value)) {
                    var numValue = Number(value);
                    if (typeof numValue === "number") {
                        params.value = formatBytes(numValue);
                    }
                }
            }
            catch (_a) { }
            return _jsx(TextCell, { params: params });
        },
    },
};
export var StoreViewerFilters = {
    folder: {
        label: "Folder",
    },
    tags: {
        label: "Tags",
        type: "csv",
    },
};
export var StoreViewerFieldsWithID = __assign({ id: {
        label: "ID",
        type: "stringWithCopy",
        minWidth: 190,
    } }, StoreViewerFields);
